/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type EvmErc1155TransferLogInfo = {
    EVT: EvmErc1155TransferLogInfo.EVT;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    TKNSINFO: EvmTokenSummaryInfo;
    TKNID: string;
    TKNVAL: string;
    TKNNAME?: string;
    IMGURL?: string;
};

export namespace EvmErc1155TransferLogInfo {

    export enum EVT {
        MINT = 'MINT',
        BURN = 'BURN',
        TRANSFER = 'TRANSFER',
    }


}

